import { z } from 'zod';

export const formSchema = z.object({
  storageLocation: z.string({ required_error: 'Selecione o SLOC' }),
  comment: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;